export default "__VITE_ASSET__abae7d7f__"